import actions from './actions';
import mutations from './mutations';
import getters from './getters'

export default {
    namespaced: true,
    state: {
        collectivite: {},
        dossier: {},
        collectivites: [],
        tarifsUsed: [],
        tarifs: [],
        options: [],
        parametres_tlpe: [],
        defaultTarifs: [
            {
                montant: 46.5,
                pourcentage_refaction: 0,
                tarif: {
                    id: 7,
                    condition_application_tarifs: [
                        {
                            id: 2,
                        },
                        {
                            id: 3,
                        },
                        {
                            id: 14,
                        },
                        {
                            id: 15,
                        },
                    ],
                },
            },
            {
                montant: 15.5,
                pourcentage_refaction: 0,
                tarif: {
                    id: 15,
                    condition_application_tarifs: [
                        {
                            id: 4,
                        },
                        {
                            id: 13,
                        },
                        {
                            id: 17,
                        },
                    ],
                },
            },
            {
                montant: 0,
                pourcentage_refaction: 0,
                tarif: {
                    id: 1,
                    condition_application_tarifs: [
                        {
                            id: 1,
                        },
                        {
                            id: 5,
                        },
                    ],
                },
            },
            {
                montant: 15.5,
                pourcentage_refaction: 0,
                tarif: {
                    id: 9,
                    condition_application_tarifs: [
                        {
                            id: 2,
                        },
                        {
                            id: 4,
                        },
                        {
                            id: 13,
                        },
                    ],
                },
            },
            {
                montant: 31,
                pourcentage_refaction: 0,
                tarif: {
                    id: 17,
                    condition_application_tarifs: [
                        {
                            id: 4,
                        },
                        {
                            id: 16,
                        },
                        {
                            id: 17,
                        },
                    ],
                },
            },
            {
                montant: 31,
                pourcentage_refaction: 0,
                tarif: {
                    id: 3,
                    condition_application_tarifs: [
                        {
                            id: 1,
                        },
                        {
                            id: 8,
                        },
                        {
                            id: 9,
                        },
                    ],
                },
            },
            {
                montant: 31,
                pourcentage_refaction: 0,
                tarif: {
                    id: 11,
                    condition_application_tarifs: [
                        {
                            id: 2,
                        },
                        {
                            id: 4,
                        },
                        {
                            id: 16,
                        },
                    ],
                },
            },
            {
                montant: 62,
                pourcentage_refaction: 0,
                tarif: {
                    id: 5,
                    condition_application_tarifs: [
                        {
                            id: 1,
                        },
                        {
                            id: 12,
                        },
                    ],
                },
            },
            {
                montant: 46.5,
                pourcentage_refaction: 0,
                tarif: {
                    id: 13,
                    condition_application_tarifs: [
                        {
                            id: 3,
                        },
                        {
                            id: 14,
                        },
                        {
                            id: 15,
                        },
                        {
                            id: 17,
                        },
                    ],
                },
            },
            {
                montant: 46.5,
                pourcentage_refaction: 0,
                tarif: {
                    id: 7,
                    condition_application_tarifs: [
                        {
                            id: 2,
                        },
                        {
                            id: 3,
                        },
                        {
                            id: 14,
                        },
                        {
                            id: 15,
                        },
                    ],
                },
            },
            {
                montant: 15.5,
                pourcentage_refaction: 0,
                tarif: {
                    id: 15,
                    condition_application_tarifs: [
                        {
                            id: 4,
                        },
                        {
                            id: 13,
                        },
                        {
                            id: 17,
                        },
                    ],
                },
            },
            {
                montant: 0,
                pourcentage_refaction: 0,
                tarif: {
                    id: 1,
                    condition_application_tarifs: [
                        {
                            id: 1,
                        },
                        {
                            id: 5,
                        },
                    ],
                },
            },
            {
                montant: 15.5,
                pourcentage_refaction: 0,
                tarif: {
                    id: 9,
                    condition_application_tarifs: [
                        {
                            id: 2,
                        },
                        {
                            id: 4,
                        },
                        {
                            id: 13,
                        },
                    ],
                },
            },
            {
                montant: 31,
                pourcentage_refaction: 0,
                tarif: {
                    id: 17,
                    condition_application_tarifs: [
                        {
                            id: 4,
                        },
                        {
                            id: 16,
                        },
                        {
                            id: 17,
                        },
                    ],
                },
            },
            {
                montant: 31,
                pourcentage_refaction: 0,
                tarif: {
                    id: 3,
                    condition_application_tarifs: [
                        {
                            id: 1,
                        },
                        {
                            id: 8,
                        },
                        {
                            id: 9,
                        },
                    ],
                },
            },
            {
                montant: 31,
                pourcentage_refaction: 0,
                tarif: {
                    id: 11,
                    condition_application_tarifs: [
                        {
                            id: 2,
                        },
                        {
                            id: 4,
                        },
                        {
                            id: 16,
                        },
                    ],
                },
            },
            {
                montant: 62,
                pourcentage_refaction: 0,
                tarif: {
                    id: 5,
                    condition_application_tarifs: [
                        {
                            id: 1,
                        },
                        {
                            id: 12,
                        },
                    ],
                },
            },
        ],
        defaultOptions: [
            {
                valeur: '0',
                type_valeur: {
                    id: 1,
                },
                option_calcul_taxe: {
                    id: 2,
                    code: 'non_scelle_exo_50',
                    libelle: `Exonération de 50% des enseignes non scellées au sol pour les redevables qui ont moins de 12 m² de surface d'enseignes cumulée.`,
                },
            },
            {
                valeur: '0',
                type_valeur: {
                    id: 1,
                },
                option_calcul_taxe: {
                    id: 1,
                    code: 'non_scelle',
                    libelle: `Exonération des enseignes non scellées au sol pour les redevables qui ont moins de 12 m² de surface d'enseignes cumulée.`,
                },
            },
            {
                valeur: '0',
                type_valeur: {
                    id: 1,
                },
                option_calcul_taxe: {
                    id: 3,
                    code: 'pre_enseigne_inf_1m5',
                    libelle: 'Exonération pour les pré-enseignes de moins de 1,5 m².',
                },
            },
        ],
    },
    actions,
    mutations,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/Collectivite/index.js